module.exports = __webpack_public_path__ + "static/media/team3.6e24691d.jpg";